import {AnyAction, combineReducers} from "redux";
import {HIDE_POPUP, SET_POPUP} from "../actions/action";

export const POPUPS =
    {
        ADD_POWER_SOURCE: 'ADD_POWER_SOURCE'
    };


//  define selectors

export const getActivePopup = state => state.popup.popupID;
export const getPopupX = state => state.popup.x;
export const getPopupY = state => state.popup.y;


/**
 * set popup id
 * @param {number} state
 * @param {AnyAction} action
 * @returns {any}
 */
function popupID(state: string = null, action: AnyAction) : string
{
    switch (action.type)
    {
        case SET_POPUP:
        {
            const {payload} = action;
            const {popup_id} = payload;

            return popup_id;
        }

        case HIDE_POPUP:
        {
            return null;
        }

        default:

            return state;
    }
}


/**
 * set popup x position
 * @param {number} state
 * @param {AnyAction} action
 * @returns {any}
 */
function x(state: number = 0, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_POPUP:
        {
            const {payload} = action;
            const {x} = payload;

            return x;
        }

        default:

            return state;
    }
}


/**
 * set popup y position
 * @param {number} state
 * @param {AnyAction} action
 * @returns {any}
 */
function y(state: number = 0, action: AnyAction) : number
{
    switch (action.type)
    {
        case SET_POPUP:
        {
            const {payload} = action;
            const {y} = payload;

            return y;
        }

        default:

            return state;
    }
}


/**
 * reducer: set the current popup ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export const popup = combineReducers({
    popupID,
    x,
    y
});


// WEBPACK FOOTER //
// ./src/ts/store/reducers/popup.ts